import { z } from "zod";

const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);
const optionalNumber = z.coerce.number().int().nullable().optional();
const optionalDate = z.coerce.date();

export const CriterioItemsSchema = z.object({
  idCriterioAvaliacaoFornecedor: z.coerce.number(),
  idItemAvaliacaoFornecedor: z.coerce.number().nullable().optional(),
  descricao: z.coerce.string().nullable(),
  nota: z.coerce.number().nullable(),
});

export const AvaliacaoFornecedorSchema = z.object({
  IdAvaliacaoFornecedor: z.number().int().default(0),
  IdOrdemCompra: optionalNumber,
  IdFornecedor: optionalNumber,
  IdFuncionarioAvaliador: optionalNumber,
  IdMedicaoTerceirizacao: optionalNumber,
  IdCentroCusto: optionalNumber,
  Data: optionalDate,
  Observacao: optionalString, 
  NroNotaFiscal: optionalString.pipe(z.string().max(500, "Máximo de 500 caracteres").nullable().optional()),

  //Formuario de mediação tercerizada
  Entregue: optionalNumber,
  NroNotaFiscalEntregue: optionalNumber,
  NrMedicaoTerceirizacao: optionalString,
  //Extra
  NomeFornecedor: optionalString,
  NomeCentroCusto: optionalString,


  criterioItems: z.array(CriterioItemsSchema),
  }).superRefine((data, ctx) => {
    if (data.Entregue === 1) {
      if (data.NroNotaFiscal === undefined || data.NroNotaFiscal === null || data.NroNotaFiscal.length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Você deve preencher este campo!',
          path: ['nroNotaFiscal'],
        });
      }
    }
  
  // data.criterioItems.forEach(x => {
  //   if (x.nota !== null && x.nota > 0 && x.nota < 3) {
  //     if (data.Observacao === undefined || data.Observacao === null || data.Observacao.trim().length === 0) {
  //       ctx.addIssue({
  //         code: z.ZodIssueCode.custom,
  //         message: 'Você deve preencher este campo!',
  //         path: ['observacao'],
  //       });
  //     }
  //   }
  // });

});

export type AvaliacaoFornecedorForm = z.infer<typeof AvaliacaoFornecedorSchema>;